const SET_MY_PRESENTATION_FOLDER_STATE = 'SET_MY_PRESENTATION_FOLDER_STATE'
const SET_SHARED_WITH_ME_FOLDER_STATE = 'SET_SHARED_WITH_ME_FOLDER_STATE'
const SET_LOADING = 'SET_LOADING'
const SET_SELECTED_PRESENTATION = 'SET_SELECTED_PRESENTATION'
const SET_DESTINATED_FOLDER_ID = 'SET_DESTINATED_FOLDER_ID'
const SET_TAB_CONTENT = 'SET_TAB_CONTENT'
const SET_SELECTED_PRESENTATIONS = 'SET_SELECTED_PRESENTATIONS'
const SET_IS_ALL_PRESENTATIONS_SELECTED = 'SET_IS_ALL_PRESENTATIONS_SELECTED'
const SET_SHOWING_MODAL_WARNING = 'SET_SHOWING_MODAL_WARNING'
const SET_IS_SHOWING_MOVE_PRESN_MODAL = 'SET_IS_SHOWING_MOVE_PRESN_MODAL'

const _state = {
  isLoading: false,
  selectedPresentation: [],
  myPresentationFolders: [],
  sharedWithMeFolders: [],
  destinatedFolderId: null,
  tabContent: null,
  selectedPresentations: [],
  isAllPresentationsSelected: false,
  showingModalWarning: false,
  isShowingMovePresnModal: false,
}

const _getters = {
  folders: (state) => {
    if (state.tabContent === 'TabMyPresentations') {
      return state.myPresentationFolders
    }
    return state.sharedWithMeFolders
  },
  selectedPresentationsId: (state) => state.selectedPresentations.map((p) => p.id),
  destinationFolder: (state, getters) => getters.folders.find((f) => f.folderId === state.destinatedFolderId),
}

const actions = {
  async setMyPresentationFoldersAction({ commit }, folders) {
    commit(SET_MY_PRESENTATION_FOLDER_STATE, {
      folders,
    })
  },
  async setSharedWithMeFoldersAction({ commit }, folders) {
    commit(SET_SHARED_WITH_ME_FOLDER_STATE, {
      folders,
    })
  },
  updateDestinatedFolderId({ commit }, destinatedFolderId) {
    commit(SET_DESTINATED_FOLDER_ID, destinatedFolderId)
  },
  updateTabContent({ commit }, tabContent) {
    commit(SET_TAB_CONTENT, tabContent)
  },
  updateSelectedPresentations({ commit }, selectedPresentations) {
    commit(SET_SELECTED_PRESENTATIONS, selectedPresentations)
  },
  updateIsAllPresentationsSelected({ commit }, isAllPresentationsSelected) {
    commit(SET_IS_ALL_PRESENTATIONS_SELECTED, isAllPresentationsSelected)
  },
  resetDestinatedFolder({ commit, getters }) {
    const enabled = getters.folders.filter((f) => !f.disabled)
    commit(SET_DESTINATED_FOLDER_ID, enabled && enabled[0] && enabled[0].folderId)
  },
  updateMovePresentationLoading({ commit }, isLoading) {
    commit(SET_LOADING, isLoading)
  },
  updateShowingModalWarning({ commit }, showingModalWarning) {
    commit(SET_SHOWING_MODAL_WARNING, showingModalWarning)
  },
  updateIsShowingMovePresnModal({ commit }, isShowingMovePresnModal) {
    commit(SET_IS_SHOWING_MOVE_PRESN_MODAL, isShowingMovePresnModal)
  },
}

const mutations = {
  [SET_MY_PRESENTATION_FOLDER_STATE](state, {
    folders,
  }) {
    state.myPresentationFolders = folders
  },
  [SET_SHARED_WITH_ME_FOLDER_STATE](state, {
    folders,
  }) {
    state.sharedWithMeFolders = folders
  },
  [SET_LOADING](state, isLoading) {
    state.isLoading = isLoading
  },
  [SET_SELECTED_PRESENTATION](state, presentations) {
    state.selectedPresentation = presentations
  },
  [SET_DESTINATED_FOLDER_ID](state, destinatedFolderId) {
    state.destinatedFolderId = destinatedFolderId
  },
  [SET_TAB_CONTENT](state, tabContent) {
    state.tabContent = tabContent
  },
  [SET_SELECTED_PRESENTATIONS](state, selectedPresentations) {
    state.selectedPresentations = selectedPresentations
  },
  [SET_IS_ALL_PRESENTATIONS_SELECTED](state, isAllPresentationsSelected) {
    state.isAllPresentationsSelected = isAllPresentationsSelected
  },
  [SET_SHOWING_MODAL_WARNING](state, showingModalWarning) {
    state.showingModalWarning = showingModalWarning
  },
  [SET_IS_SHOWING_MOVE_PRESN_MODAL](state, isShowingMovePresnModal) {
    state.isShowingMovePresnModal = isShowingMovePresnModal
  },
}

const movePresentation = {
  namespaced: true,
  state: _state,
  getters: _getters,
  actions,
  mutations,
}

export default movePresentation
